import {END, READY, REGISTER} from 'shared/constant/lookup/eventState'

/**
 * Check if an event has started based on event date and current time
 * @param {string} eventDate - The event date in ISO string format (e.g., '2025-09-30T13:46:00.000Z')
 * @returns {boolean} true if event has started, false if not started yet
 */
export const isEventStarted = (eventDate) => {
	if (!eventDate) return false

	const now = new Date()
	const eventDateTime = new Date(eventDate)

	return now >= eventDateTime
}

/**
 * Check if user can join the event based on event data
 * @param {Object} eventData - The event data object
 * @param {string} eventData.event_date - The event date in ISO string format
 * @param {boolean} eventData.user_can_join - Whether user is allowed to join
 * @param {boolean} eventData.has_joined - Whether user has already joined
 * @param {number} eventData.event_state - The current state of the event
 * Event state mapping (based on existing getEventStatus utility):
 * - 0: Unknown/Not started
 * - 1: Scheduled
 * - 2: In progress
 * - 3: Completed
 * - 4: Taking
 * - 5: Cancelled
 * @returns {boolean} true if join button should be shown, false otherwise
 */
export const canJoinEvent = (eventData) => {
	if (!eventData) return false
	const {user_can_join, has_joined, event_state} = eventData
	// Don't show join button if user already joined
	if (has_joined) return false
	// Don't show join button if event is completed
	if (event_state === END) return false
	// Don't show join button if user is not allowed to join
	if (!user_can_join) return false

	return true
}

/**
 * Get event timing status
 * @param {string} eventDate - The event date in ISO string format
 * @returns {string} 'not_started' | 'started' | 'invalid_date'
 */
export const getEventTimingStatus = (eventDate) => {
	if (!eventDate) return 'invalid_date'

	const now = new Date()
	const eventDateTime = new Date(eventDate)

	if (isNaN(eventDateTime.getTime())) return 'invalid_date'

	return now >= eventDateTime ? 'started' : 'not_started'
}

export const isStaringSoon = (eventData) => {
	if (!eventData) return false
	const {event_state} = eventData
	if (event_state === REGISTER || event_state === READY) return true
	return false
}

export const getTicketInfo = (data) => {
	const {required_tickets} = data || {}
	const {remaining_reentries} = data?.participation_history || {}
	const {total_available} = data?.available_tickets || {}

	// Parse all values to numbers for safe comparison
	const requiredTicketsNum = Number(required_tickets) || 0
	const totalAvailableNum = Number(total_available) || 0

	const isEnoughReEntry = !remaining_reentries
		? true
		: remaining_reentries || false

	const isEnoughVouchers = totalAvailableNum >= requiredTicketsNum
	return {
		isEnoughReEntry,
		isEnoughVouchers,
	}
}

export const isUsedTicket = (data) => {
	const isUsed = Number(data?.available_tickets?.total_available) || 0

	return isUsed > 0 ? false : true
}
